module.exports = __webpack_public_path__ + "img/signup.7b3ab3d.png";